import React from "react";
import IconComponent from "../Icons/IconComponent";

const ContentType = ({ typeId }) => {

    let iconName = null;

    switch (typeId.toString()) {
        case "10": iconName = "link"; break;
        case "20": iconName = "photo"; break;
        case "30": iconName = "video"; break;
        case "40": iconName = "pdf"; break;
        case "50": iconName = "pdf"; break;
        case "70": iconName = "agenda"; break;
        case "80": iconName = "directory"; break;
        case "110": iconName = "ad"; break;
        case "150": iconName = "flipcard"; break;
        case "260": iconName = "checkers"; break;
        case "160": iconName = "memory"; break;
        case "240": iconName = "m4"; break;
        case "410": iconName = "instagram"; break;
        case "100": iconName = "itinerary"; break;
        case "170": iconName = "jobboard"; break;
        case "90": iconName = "map"; break;
        case "120": iconName = "mediagal"; break;
        case "250": iconName = "feed"; break;
        case "220": iconName = "survey"; break;
        case "210": iconName = "X"; break;
        case "290": iconName = "supermiro"; break;
        case "500": iconName = "jalios"; break;
        case "510": iconName = "jalios"; break;
        case "130": iconName = "wordpress"; break;
        case "180": iconName = "wordpress"; break;
        case "190": iconName = "wordpress"; break;
        case "520": iconName = "echolu"; break;
        case "140": iconName = "pdflib"; break;
        case "60": iconName = "pharmacy"; break;
        case "300": iconName = "hero"; break;
    }

    if (iconName) {iconName = "logo_" + iconName;}

    return <div style={{
        width: "48px",
        height: "48px",
        padding: "0 11px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "3px",
        border: "1px solid var(--grey-light)",
        background: "var(--grey-lighter)"
    }}>
        <IconComponent
            nameIcon={iconName}
            color={"carbone"}
            dimensions={"24"}
            folder={"ContentType"}
        />
    </div>;
};

export default ContentType;
